module.exports = __webpack_public_path__ + "img/kommune-819.89d26be2.svg";